import React, { useState, useMemo } from "react";
import useSWR from "swr";
import { useNavigate } from "react-router-dom";
import DataGrid, {
  Column,
  Editing,
  Button,
  Texts,
  Lookup,
  Form,
  Item,
  SearchPanel,
  Scrolling,
  RequiredRule,
  Toolbar,
} from "devextreme-react/data-grid";
import { Popup as MyPopup, ToolbarItem } from "devextreme-react/popup";
import { Form as MyForm, SimpleItem, GroupItem } from "devextreme-react/form";
import { Button as MyButton } from "devextreme-react/button";
import LoadingSpinnerModal from "../../Components/LoadingSpinnerModal";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import useFetch from "../../Hooks/useFetch";
import useGetAllUsers from "../../Hooks/useGET/useGetAllUsers";
import { checkRoles } from "../../Utils/helper";
import ActionNotifications from "../../Components/ActionNotifications";
import ErrorMessage from "../../Components/ErrorMessage";
import "./styles.css";

export default function PCards() {
  const navigate = useNavigate(),
    fetch = useFetch(navigate),
    [notifyResponse, setResponse] = useState({}),
    [state, setState] = useState({
      showAssignPopup: false,
      showUnassignPopup: false,
      showDeletedToggle: false,
      addingPcard: false,
      assignedSupervisors: [],
      unassignSupervisorsBody: {},
      assignSupervisorsBody: {},
    }),
    { allUsers, isLoading: allUsersIsLoading } = useGetAllUsers(),
    { data: assignedData, error: assignedError } = useSWR(
      `${apiBaseURL}/api/PCard/assign`,
    ),
    assignedSupervisors = assignedData?.data?.map((x) => ({
      id: x.pCard.id,
      assignedSupervisor: `${x.supervisingEmployee.firstName} ${x.supervisingEmployee.lastName}`,
      superVisorId: x.supervisingEmployee.id,
    })),
    { data, mutate: pcardMutate, error } = useSWR(`${apiBaseURL}/api/PCard`),
    pcards = data?.data?.map((x) => ({
      id: x.id,
      cardHolder: x.cardHolder.id,
      assignedSupervisors: assignedSupervisors
        ?.map((y) => (y.id === x.id ? y.superVisorId : null))
        .filter((x) => {
          return x != null;
        }),
    }));
  //console.log("const pcards: ", pcards);
  //console.log('setState pcards: ', state.pcards);

  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };

  const saveButtonOptions = {
    text: "Save",
    useSubmitBehavior: true,
    onClick: (e) => {
      unassignSupervisors(state.unassignSupervisorsBody);
    },
  };

  const saveButtonOptionsAssign = {
    text: "Save",
    useSubmitBehavior: true,
    onClick: (e) => {
      assignSupervisors(state.assignSupervisorsBody);
    },
  };

  const idEditorOptions = {
    items: pcards,
    searchEnabled: true,
    value: "",
    valueExpr: "id",
    displayExpr: "id",
  };

  const supervisorEditorOptions = {
    items: allUsers,
    searchEnabled: true,
    value: "",
    valueExpr: "value",
    displayExpr: "label",
  };

  const validationRules = {
    pcard: [{ type: "required", message: "Pcard ID is required." }],
    supervisor: [
      { type: "required", message: "Superivor's name is required." },
    ],
  };

  const onShowPopup = () => {
    if (state.showUnassignPopup) {
      return (
        <MyPopup
          visible={state.showUnassignPopup}
          onHiding={() => setState({ ...state, showUnassignPopup: false })}
          hideOnOutsideClick={true}
          showTitle={true}
          title="Unassign Supervisors"
          maxWidth={700}
          height="auto"
          resizeEnabled={true}
        >
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={saveButtonOptions}
          />

          <MyForm
            id="form"
            formData={state.unassignSupervisorsBody}
            onFieldDataChanged={(e) =>
              setState((prev) => ({
                ...prev,
                unassignSupervisorsBody: {
                  ...prev.unassignSupervisorsBody,
                  [e.dataField]: e.value,
                },
              }))
            }
          >
            <GroupItem>
              <SimpleItem
                dataField="PcardID"
                editorType="dxSelectBox"
                editorOptions={idEditorOptions}
                validationRules={validationRules.pcard}
              />
              <SimpleItem
                dataField="SupervisorName"
                editorType="dxSelectBox"
                editorOptions={supervisorEditorOptions}
                validationRules={validationRules.supervisor}
              />
            </GroupItem>
          </MyForm>
        </MyPopup>
      );
    } else if (state.showAssignPopup) {
      return (
        <MyPopup
          visible={state.showAssignPopup}
          onHiding={() => setState({ ...state, showAssignPopup: false })}
          hideOnOutsideClick={true}
          showTitle={true}
          title="Assign Supervisors"
          maxWidth={700}
          height="auto"
          resizeEnabled={true}
        >
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={saveButtonOptionsAssign}
          />

          <MyForm
            id="form"
            formData={state.assignSupervisorsBody}
            onFieldDataChanged={(e) =>
              setState((prev) => ({
                ...prev,
                assignSupervisorsBody: {
                  ...prev.assignSupervisorsBody,
                  [e.dataField]: e.value,
                },
              }))
            }
          >
            <GroupItem>
              <SimpleItem
                dataField="PcardID"
                editorType="dxSelectBox"
                editorOptions={idEditorOptions}
                validationRules={validationRules.pcard}
              />
              <SimpleItem
                dataField="SupervisorName"
                editorType="dxSelectBox"
                editorOptions={supervisorEditorOptions}
                validationRules={validationRules.supervisor}
              />
            </GroupItem>
          </MyForm>
        </MyPopup>
      );
    }
  };

  const unassignSupervisors = async (e) => {
    console.log(e);

    const response = await fetch.delete(
      `${apiBaseURL}/api/pcard/assign?userid=${e.SupervisorName}&pcardId=${e.PcardID}`,
    );
    console.log(response);
    console.log(data);
    setState({ ...state, showUnassignPopup: false });

    if (fetchSuccessful(response)) {
      pcardMutate();
    }
  };

  const assignSupervisors = async (e) => {
    console.log(e);

    const response = await fetch.post(
      `${apiBaseURL}/api/pcard/assign?userid=${e.SupervisorName}&pcardId=${e.PcardID}`,
    );

    if (fetchSuccessful(response)) {
      pcardMutate();
    }
    setState({ ...state, showAssignPopup: false });
  };

  const onRowRemoved = async (e) => {
    const response = await fetch.delete(
      `${apiBaseURL}/api/PCard?id=${e.data.id}`,
    );

    if (fetchSuccessful(response)) {
      pcardMutate();
    }
  };

  const onInitNewRow = (e) => {
    setState({ ...state, addingPcard: true });
  };
  const onEditingStart = (e) => {
    setState({ ...state, addingPcard: false });
  };

  const cellTemplate = (container, options) => {
    const noBreakSpace = "\u00A0";
    const text = (options.value || [])
      .map((element) => options.column.lookup.calculateCellValue(element))
      .join(", ");
    container.textContent = text || noBreakSpace;
    container.title = text;
  };

  const onEditorPreparing = (e) => {
    if (e.parentType === "dataRow" && e.dataField === "assignedSupervisors") {
      e.editorName = "dxTagBox";
      e.editorOptions.dataSource = allUsers;
      e.editorOptions.showSelectionControls = true;
      e.editorOptions.displayExpr = "label";
      e.editorOptions.valueExpr = "value";
      e.editorOptions.value = e.value || [];
      e.editorOptions.onValueChanged = (x) => {
        //replace?
        console.log(x);
        e.setValue(x.value);
      };
    }
  };

  const allowEditing = async (e) => {
    console.log(e);
    let response = null;
    let editType = e.changes.find((x) => x.type === "update");
    let addType = e.changes.find((x) => x.type === "insert");

    console.log(editType);
    console.log(addType);
    if (editType) {
      const editBody = {
        Id: editType.data.id,
        userId: editType.data.cardHolder,
      };

      console.log(editBody);
      response = await fetch.put(`${apiBaseURL}/api/pcard?`, editBody);
    } else {
      const addBody = {
        UserId: addType?.data?.cardHolder,
      };

      console.log(addBody);
      response = await fetch.post(`${apiBaseURL}/api/pcard?`, addBody);
    }

    if (fetchSuccessful(response)) {
    }
  };
  const renderGrid = () => {
    const isButtonVisible = (e) => {
      if (e.row.data.type === 1) {
        return true;
      }
      return false;
    };

    if (!data && !error && !assignedData && !assignedError && allUsersIsLoading)
      return <LoadingSpinnerModal show />;

    return (
      <DataGrid
        dataSource={pcards}
        allowColumnResizing={true}
        columnAutoWidth={true}
        height="auto"
        onEditorPreparing={onEditorPreparing}
        onSaved={allowEditing}
        onRowRemoved={onRowRemoved}
        onInitNewRow={onInitNewRow}
        onEditingStart={onEditingStart}
        wordWrapEnabled={true}
        showBorders={true}
        // elementAttr={{ class: "pcards-grid" }}
      >
        <Toolbar>
          <Item
            location="before"
            locateInMenu="never"
            render={() => (
              <div>
                <h1 className="white">PCards</h1>
              </div>
            )}
          />
          <Item locateInMenu="auto">
            <MyButton
              text="Assign Supervisors"
              type="normal"
              stylingMode="contained"
              onClick={() => setState({ ...state, showAssignPopup: true })}
            />
          </Item>
          <Item locateInMenu="auto">
            <MyButton
              text="Unassign Supervisors"
              type="normal"
              stylingMode="contained"
              onClick={() => setState({ ...state, showUnassignPopup: true })}
            />
          </Item>
          <Item name="addRowButton" />
        </Toolbar>
        <Scrolling mode="virtual" />
        <Editing
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
          mode="row"
        />

        <SearchPanel
          id="searchpanel"
          visible={true}
          maxWidth={275}
          searchVisibleColumnsOnly={true}
          placeholder="Search..."
        />

        <Column type="buttons">
          <Button name="edit" visible={true} />
          <Button name="delete" visible={true} />
        </Column>
        <Column
          dataField="id"
          width={100}
          alignment="left"
          allowEditing={false}
        />
        <Column dataField="cardHolder" minWidth={200}>
          <Lookup dataSource={allUsers} valueExpr="value" displayExpr="label" />
          <RequiredRule />
        </Column>

        <Column
          dataField="assignedSupervisors"
          caption="Assigned Supervisors"
          cellTemplate={cellTemplate}
        >
          <Lookup dataSource={allUsers} valueExpr="value" displayExpr="label" />
          <RequiredRule />
        </Column>
      </DataGrid>
    );
  };
  return (
    <div className="px-lg-4 content">
      <ActionNotifications response={notifyResponse} />
      {onShowPopup()}
      <div className="flexBoxRowSCC">
        <div className="px-2 page-content pcard-grid">
          <div className="contentBox my-3">
            {!error ? renderGrid() : <ErrorMessage />}
          </div>
        </div>
      </div>
    </div>
  );
}
